export default "__VITE_ASSET__DtzPAwyY__"